/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Component, OnInit } from '@angular/core';
//import {Configuration} from './../../services/config.service';

@Component({
  selector: 'menu', // <my-app></my-app>
  template: require('./menu.html')
})
export class Menu implements OnInit{

  public sesionControl:boolean = false;
  public pais:any = {};

  constructor() {
    if(localStorage.getItem('login')){
      this.sesionControl = true;
    }
  }

  cerrarSesion(){
    localStorage.removeItem('login');
    this.sesionControl = false;
    location.reload();
  }


  ngOnInit() {
    this.pais = localStorage.getItem('pais');
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/menu/menu.component.ts